import React, { useContext } from 'react'

import { Box } from '../../../compositions/Box/Box'
import { GalleryBreach } from '../../../user-registration/breach/GalleryBreach'
import { Gallery } from '../../../content/Gallery/Gallery'
import { GalleryPublicationProps } from '../SharedPublication.routing'
import { ConfigurationContext } from '@news-mono/web-common'
import { getBaseUrl } from '@news-mono/web-common'
import { AdUnitWrapper } from '../../../advertising/AdUnit/AdUnitWrapper'
import { useSectionMetaInfo } from '../../../__helpers/use-section-meta'

export const TheWestGallery: React.FC<GalleryPublicationProps> = ({
    gallery,
    galleryMeta,
    location,
    onEvent,
    adState,
}) => {
    const { publicUrl } = useContext(ConfigurationContext)
    const sectionMeta = useSectionMetaInfo()
    const url =
        getBaseUrl(publicUrl, sectionMeta) +
        '/' +
        gallery.primaryTopic.id +
        '/' +
        gallery.slug

    return (
        <Box verticalSpacing="md">
            <GalleryBreach
                location={location}
                onEvent={onEvent}
                publicationId={gallery.id}
                images={gallery.images}
                slug={gallery.slug}
                requiredAccess={gallery.requiredAccess}
            >
                {({ images }, entitled) => (
                    <Gallery
                        entitled={entitled}
                        requiredAccess={gallery.requiredAccess}
                        title={gallery.heading}
                        images={images}
                        adFrequency={3}
                        publicationDate={gallery.publicationDate}
                        profile={gallery.profile}
                        byline={gallery.byline}
                        source={gallery.source}
                        ads={galleryMeta.galleryAds.map((ad) => (
                            <AdUnitWrapper
                                hiddenUntilLoaded={ad.hiddenUntilLoaded}
                                noticePosition={ad.noticePosition}
                                padding={ad.padding}
                                adState={adState}
                                unitId={ad.slot.id}
                                onEvent={onEvent}
                            />
                        ))}
                        mainImage={gallery.heroImage}
                        shareUrl={url}
                        onEvent={onEvent}
                    />
                )}
            </GalleryBreach>
        </Box>
    )
}
